// Vangt tikfouten in e-mailadressen af vóór het versturen. Zo'n 3% van de
// leads tikte iets als "gmail.comi", "gmail.co", "hotmail.con" of
// "hotmall.com": die mail komt nooit aan en de lead is weg. Geeft het
// verbeterde adres terug, of null als er niets op aan te merken is.
// (Zelfde bestand staat in floawch: src/utils/emailTypo.js.)

const PROVIDERS = ['gmail', 'hotmail', 'outlook', 'icloud', 'live', 'yahoo', 'ziggo', 'kpnmail', 'msn'];

// Bestaande aanbieders die op een bekende naam lijken maar kloppen ("mail.com"
// is echt, geen tikfout van gmail.com): nooit verbeteren.
const REAL_LOOKALIKES = ['mail', 'email', 'gmx', 'ymail', 'aol', 'me', 'mac', 'life', 'love', 'lives', 'upcmail'];

// Welke eindes horen bij welke provider (eerste = standaard)
const FOREIGN = ['be', 'de', 'fr', 'es', 'it', 'co.uk'];
// Hotmail, Outlook, Live en Yahoo bestaan in veel landen (outlook.pt, live.dk):
// elk landeinde van twee letters is daar geldig, behalve deze bekende tikfouten.
const MULTI_COUNTRY = ['hotmail', 'outlook', 'live', 'yahoo'];
const TYPO_TLDS = ['co', 'cm', 'om', 'nk', 'ml', 'bl', 'ni', 'nn'];
const TLDS = {
  gmail: ['com'],
  icloud: ['com'],
  yahoo: ['com', 'nl', ...FOREIGN],
  msn: ['com'],
  hotmail: ['com', 'nl', ...FOREIGN],
  outlook: ['com', 'nl', ...FOREIGN],
  live: ['nl', 'com', ...FOREIGN],
  ziggo: ['nl'],
  kpnmail: ['nl'],
};

// Aantal bewerkingen tussen twee woorden (invoegen, weghalen, vervangen, omwisselen)
function distance(a, b) {
  const d = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 0; j <= b.length; j++) d[0][j] = j;
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
  }
  return d[a.length][b.length];
}

export function suggestEmailFix(raw) {
  const email = String(raw || '').trim().toLowerCase();
  const at = email.lastIndexOf('@');
  if (at < 1 || at === email.length - 1) return null;
  const local = email.slice(0, at);
  const domain = email.slice(at + 1).replace(/,/g, '.').replace(/\.+$/, '');
  const dot = domain.indexOf('.');
  const name = dot === -1 ? domain : domain.slice(0, dot);
  const tld = dot === -1 ? '' : domain.slice(dot + 1);
  if (!name || REAL_LOOKALIKES.includes(name)) return null;

  // Naam van de provider: exact, of één tikfout ernaast (twee bij langere namen)
  let provider = PROVIDERS.includes(name) ? name : null;
  if (!provider && name.length >= 4) {
    const near = PROVIDERS
      .map((p) => ({ p, n: distance(name, p) }))
      .filter((x) => x.n <= (x.p.length >= 6 ? 2 : 1))
      .sort((x, y) => x.n - y.n)[0];
    if (near) provider = near.p;
  }
  if (!provider) return null; // onbekend domein (werk, eigen domein): niet aankomen

  const allowed = TLDS[provider];
  const countryTld = MULTI_COUNTRY.includes(provider) && /^(com?\.)?[a-z]{2}$/.test(tld) && !TYPO_TLDS.includes(tld);
  let fixedTld = allowed.includes(tld) || countryTld ? tld : null;
  if (!fixedTld) {
    // "con", "vom", "comi", "coml", "co", "cm" → com; "nk", "ml", "n" → nl
    const near = allowed
      .map((t) => ({ t, n: distance(tld, t) }))
      .sort((x, y) => x.n - y.n)[0];
    fixedTld = near && near.n <= 2 ? near.t : allowed[0];
  }

  const fixed = `${local}@${provider}.${fixedTld}`;
  return fixed === email ? null : fixed;
}
